export const FRAME_HEADER_SIZE = 21;
export const FrameType = {
    VIDEO_KEYFRAME: 0x01,
    VIDEO_DELTA: 0x02,
    AUDIO: 0x10,
    CURSOR: 0x20,
};
export function encodeFrameHeader(h) {
    const buf = new Uint8Array(FRAME_HEADER_SIZE);
    const view = new DataView(buf.buffer);
    view.setUint8(0, h.frameType);
    view.setUint32(1, h.sessionId, false);
    view.setUint32(5, h.seq, false);
    view.setBigUint64(9, h.captureTs, false);
    view.setUint16(17, h.monitorId, false);
    view.setUint16(19, h.flags, false);
    return buf;
}
export function decodeFrameHeader(buf) {
    if (buf.byteLength < FRAME_HEADER_SIZE) {
        throw new Error(`frame header too small: got ${buf.byteLength}, need ${FRAME_HEADER_SIZE}`);
    }
    const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
    return {
        frameType: view.getUint8(0),
        sessionId: view.getUint32(1, false),
        seq: view.getUint32(5, false),
        captureTs: view.getBigUint64(9, false),
        monitorId: view.getUint16(17, false),
        flags: view.getUint16(19, false),
    };
}
//# sourceMappingURL=frame-header.js.map